import { defineMessages } from "react-intl"

export const messages = {
  required: {
    id: "required",
    defaultMessage: "Required",
  },
  radioRequired: {
    id: "radio-required",
    defaultMessage: "Please select one option",
  },
  minChar: {
    id: "minChar",
    defaultMessage: "Must contains at least {min} characters",
    values: { min: 2 },
  },
  maxChar: {
    id: "maxChar",
    defaultMessage: "Must not exceed {max} characters",
    values: { max: 35 },
  },
  dobNoFuture: {
    id: "dobNoFuture",
    defaultMessage: "Date of birth cannot be in the future",
  },
  invalidZipCode: {
    id: "invalidZipCode",
    defaultMessage: "Allow only 5 digit number",
  },
  invalidState: {
    id: "invalidState",
    defaultMessage: "Invalid state code",
  },
  invalidEmail: {
    id: "invalidEmail",
    defaultMessage: "Invalid email format",
  },
  invalidEmailChar: {
    id: "invalidEmailChar",
    defaultMessage: "Email contains invalid character",
  },
  duplicateEmails: {
    id: "duplicateEmails",
    defaultMessage: "Duplicate emails are not allowed",
  },
}

export default defineMessages(messages)
